import React from 'react';
import { useTheme } from '@context/themeContext';

export type SearchHeaderProps = {
    leftFields?: React.ReactNode;
    rightFields?: React.ReactNode;
};

const SearchHeader: React.FC<SearchHeaderProps> = function ({ leftFields, rightFields }) {
    const { theme } = useTheme();

    return (
        <div className={`header-search ${theme}`}>
            <div className="header-search__left">{leftFields}</div>
            <div className="header-search__right">{rightFields}</div>
        </div>
    );
};

export default SearchHeader;
